import * as React from 'react';
import styled from 'styled-components';
import MuiSelect, { SelectProps as MuiSelectProps } from '@material-ui/core/Select';

const StyledSelect = styled(MuiSelect)``;

export type DSSelectProps = MuiSelectProps & { ['data-cy']?: string };

export const DSSelect: React.FC<DSSelectProps> = props => <StyledSelect {...props} />;
DSSelect.displayName = 'DSSelect';
